module.exports = __webpack_public_path__ + "static/media/signupV2-professionals.56b0a763.svg";